require('./bootstrap');
require('./jquery-ui.min');
require('../../shared/greedynav/greedynav');
require('../../shared/bootstrap-4.0.0-beta.2/dist/js/bootstrap.min');
require('./header');
require('./sly.min');
require('./plugins');
require('./jquery.cookie');
require('../../shared/fullcalendar-2.1.1/fullcalendar');
require('../../shared/fullcalendar-2.1.1/lang-all');
require('cropit.jquery3');
window.JSZip = require('jszip/dist/jszip.min');
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.addVirtualFileSystem(pdfFonts);
require('bootstrap-autocomplete/dist/latest/bootstrap-autocomplete.min');

// Disable bootstrap-autocomplete built-in highlighting (<b>...</b>) globally.
(function ($) {
    if (!$.fn || !$.fn.autoComplete) {
        return;
    }

    const originalAutoComplete = $.fn.autoComplete;

    $.fn.autoComplete = function (...args) {
        const result = originalAutoComplete.apply(this, args);

        this.each(function () {
            const instance = $(this).data('autoComplete');

            if (instance && instance._dd && typeof instance._dd.showMatchedText === 'function') {
                instance._dd.showMatchedText = function (text) {
                    return text;
                };
            }
        });

        return result;
    };
})(jQuery);

require('datatables.net-buttons/js/dataTables.buttons.js');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('../../shared/media-boxes/components/Fancybox/jquery.fancybox.min');
require('../../shared/media-boxes/components/Isotope/jquery.isotope.min');
require('../../shared/media-boxes/components/imagesLoaded/jquery.imagesLoaded.min');
require('../../shared/media-boxes/components/Transit/jquery.transit.min');
require('../../shared/media-boxes/components/jQuery Easing/jquery.easing');
require('../../shared/media-boxes/components/Waypoints/waypoints.min');
require('../../shared/media-boxes/components/Modernizr/modernizr.custom.min');
require('../../shared/media-boxes/components/Magnific Popup/jquery.magnific-popup.min');
require('../../shared/media-boxes/js/jquery.mediaBoxes.dropdown');
require('../../shared/media-boxes/js/jquery.mediaBoxes');
require('../../shared/js/app.js');

window.Moment = require('moment');

import {MediaBoxes} from "./components/MediaBoxes";
import {GoogleTagManager} from "./libraries/GoogleTagManager";
import {TweakwiseEventTag} from "./libraries/TweakwiseEventTag";
import {OrderImagesDownloader} from "./components/OrderImagesDownloader";

if (useGtmEcommerceEvents) {
    let googleTagManager = new GoogleTagManager();
    googleTagManager.init();
}

if (useTweakwiseEventTag) {
    const tweakwiseEventTag = new TweakwiseEventTag();
    tweakwiseEventTag.init();
}

addEventListener('DOMContentLoaded', e => {
    const mediaBoxes = new MediaBoxes();

    mediaBoxes.init();

    // Delegated bindings: DataTables redraws table rows via ajax (e.g. search/sort/paging),
    // so handlers bound only on 'init.dt' (which fires once) never reach buttons in rows
    // rendered by later draws. Binding on document keeps them working for every draw.
    $(document).on('click', '.historic-order-image-download-btn', function (e) {
        e.preventDefault();

        if (sessionStorage.getItem(this.id) === 'true') {
            this.classList.add('disabled');
        }

        let orderImagesDownloader = new OrderImagesDownloader();
        orderImagesDownloader.download(this);
        sessionStorage.setItem(this.id, 'true');
    });

    $(document).on('click', '.order-image-download-btn', function () {
        sessionStorage.setItem(this.id, 'true');
    });

    $('table').on('draw.dt', function () {
        $('.historic-order-image-download-btn, .order-image-download-btn').each(function () {
            if (sessionStorage.getItem(this.id) === 'true') {
                this.classList.add('disabled');
            }
        });

        $('.dt-length .dt-input').addClass('custom-select');
        $('.dt-search .dt-input').addClass('form-control form-control-sm');
    });
});
